export default "__VITE_ASSET__C4Zz0xVx__"